import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-gear-icon",
  templateUrl: "./gear-icon.component.html",
  styleUrls: ["./gear-icon.component.scss"],
})
export class GearIconComponent implements OnInit {
  @Input()
  overrideStyle = {};
  constructor() {}

  ngOnInit(): void {}
}
